module.exports = __webpack_public_path__ + "media/images/ic_lit_bebe-4bf7e78586a242560030333ebb2c784b.svg";